define('shared/initializer/form/adapters/mixins/ClientIdTracking',[ 
    '../../constants', 
    'shared/lib/RSVP',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/tracking/clientIds'
], 
function ( 
    constants, 
    RSVP, 
    FormDataDispatcher, 
    clientIds
) {
    'use strict';

    function Ctor(){

    }

    var p = Ctor.prototype;

    p.doBeforeSubmit = function(){
        var me = this;
        var basePromise = RSVP.resolve();

        return basePromise.then(function(){
            return new FormDataDispatcher(me.$form).dispatch({
                items:{
                    'GAClientId': {
                        sources: [{type: 'clientId', key: clientIds.CONSTANT.GAClientId, allowUndefined: true}],
                        targets: [
                            {type: 'form', key: constants.FIELD.MemberGAClientId},
                            {type: 'form', key: constants.FIELD.GAClientId}
                        ]
                    },
                    'AdobeVisitorId': {
                        sources: [{type: 'clientId', key: clientIds.CONSTANT.AdobeVisitorId, allowUndefined: true}],
                        targets: [
                            {type: 'form', key: constants.FIELD.MemberAdobeVisitorId},
                            {type: 'form', key: constants.FIELD.AdobeVisitorId}
                        ]
                    }
                },
                timeout: 1000 * 5
            });
        });
    };

    return Ctor;
});
